import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const useIsLoggedIn = () => {
  const { currentUser } = useCurrentUserContext();
  return !!currentUser;
};
